
<div class="container">
  <div class="row mt-5">
    <div class="col">
<!--      <h4 >{{"conditions.cardholder_agreement" | translate:{productName: productName} }}</h4>-->
      <!--h3 >{{"conditions.title" | translate}}</h3-->
<!--      <p class="m-0" style="text-align: right"><small class="text-muted" >Rev. 01/24</small></p>-->

      <br>
      <!-- region ShortForm -->
      <p class="mb-0 text-center" style="font-size: 1.2rem; font-family: Arial, sans-serif;">{{"conditions.short_form.title" | translate}}</p>
      <article style="max-width: 700px" class="mx-auto">
        <section>
          <div>
            <span>{{"conditions.short_form.monthly_charge_title" | translate}}</span>
            <strong class="strong-short-form">{{ monthlyFee ? monthlyFee : 'N/A' }}</strong>
          </div>
          <div>
            <span>{{"conditions.short_form.purchase_pin_title" | translate}}</span>
            <strong class="strong-short-form">{{ purchasePin | currency:'USD':'symbol':'1.2-2':'en-US' }}</strong>
          </div>
          <div>
            <span>{{"conditions.short_form.atm_withdrawal_title" | translate}}</span>
            <strong class="strong-short-form">{{ atmWithdrawal | currency:'USD':'symbol':'1.2-2':'en-US' }}</strong>
          </div>
          <div>
            <span>{{"conditions.short_form.cash_refill_title" | translate}}</span>
            <strong class="strong-short-form">{{ cashReload | currency:'USD':'symbol':'1.2-2':'en-US' }}</strong>
          </div>
        </section>
        <section>
          <span>{{"conditions.short_form.balance_inquiry_row" | translate}}</span>
          <span>{{balanceInquiry | currency:'USD':'symbol':'1.2-2':'en-US'}}</span>
        </section>
        <section>
          <span>{{"conditions.short_form.customer_service_row" | translate}}</span>
          <span>{{customerService | currency:'USD':'symbol':'1.2-2':'en-US'}}</span>
        </section>
        <section class="section-strong">
          <span>{{"conditions.short_form.inactivity" | translate}} <span style="font-size: 0.6rem">{{"conditions.short_form.inactivity_row" | translate}}</span></span>
          <span>{{inactivityCost | currency:'USD':'symbol':'1.2-2':'en-US'}}&nbsp;<span style="font-size: 0.6rem">{{"conditions.short_form.monthly_txt" | translate}}</span></span>
        </section>
        <section class="section-medium">
          <div>
            <strong>{{"conditions.short_form.other_types_charges_row" | translate}}</strong>
              &nbsp;
            <span>{{"conditions.short_form.this_expamle_one_row" | translate}}</span>
          </div>
          <span></span>
        </section>
        <section class="section-medium">
          <span>{{"conditions.short_form.card_purchase_row" | translate}}</span>
          <span>{{cardPurchase | currency:'USD':'symbol':'1.2-2':'en-US'}}</span>
        </section>
        <section class="section-medium">
          <span>{{"conditions.short_form.pin_purchase_row" | translate}}</span>
          <span>{{pinPurchase | currency:'USD':'symbol':'1.2-2':'en-US'}}</span>
        </section>
        <section>
          <div class="mt-5 pt-1">
            <strong>{{"conditions.short_form.descript_3_text" | translate}}</strong>
          </div>
          <span>{{"conditions.short_form.descript_4_text" | translate}}</span>
          <span class="translate-new-line" style="padding-bottom: 0 !important;">{{"conditions.short_form.short_form_footer" | translate }} <b>{{this.phoneNumber}}</b> {{"conditions.short_form.short_form_footer_2" | translate }} <b><a href="https://{{this.customerHost}}" target="_blank">{{this.customerHost}}</a></b>. </span>
        </section>
      </article>
      <div class="footer-article mx-auto">
        <div style="padding-bottom: 0 !important;">{{ "conditions.short_form.descript_5_text" | translate :{ programName: productName } }}</div>
        <div class="mt-1">{{ "conditions.short_form.disclaimer_footer" | translate}}</div>
      </div>

      <!-- endregion ShortForm -->
      <br>
      <br>
      <!-- region LongForm -->
      <p class="mb-0 text-center" style="font-size: 1.1rem; font-family: Arial, sans-serif;">{{"conditions.long_form.long_form_title_1" | translate}}<b>{{"conditions.long_form.long_form_title_2" | translate}}</b>{{"conditions.long_form.long_form_title_3" | translate: { programName: productName } }}</p>
      <table class="table table-bordered table-sm table-responsive long-form">
        <thead class="custom-thead">
        <tr>
          <th >{{"conditions.long_form.all_fees" | translate}}</th>
          <th >{{"conditions.long_form.amount" | translate}}</th>
          <th >{{"conditions.long_form.details" | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="3" >{{"conditions.long_form.to_get_started" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.card_purchase" | translate}}</td>
          <td class="numbers">$10.00</td>
          <td >{{"conditions.long_form.card_purchase_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.add_money" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.ach_deposit" | translate}}</td>
          <td class="numbers">$0.00</td>
          <td >{{"conditions.long_form.ach_deposit_fee" | translate}}</td>
        </tr>

        <tr>
          <td colspan="3" >{{"conditions.long_form.spend_money" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.signature_purchase" | translate}}</td>
          <td>$0.00</td>
          <td >{{"conditions.long_form.signature_purchase_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.pin_purchase" | translate}}</td>
          <td>$0.50</td>
          <td >{{"conditions.long_form.pin_purchase_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.get_cash" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.atm_withdrawal" | translate}}</td>
          <td>$2.50</td>
          <td >{{"conditions.long_form.atm_withdrawal_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.cash_back_pos" | translate}}</td>
          <td>$0.50</td>
          <td >{{"conditions.long_form.cash_back_pos_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.information" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.customer_service" | translate}}</td>
          <td>$0.00</td>
          <td >{{"conditions.long_form.customer_service_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.atm_balance_inquiry" | translate}}</td>
          <td>$0.50</td>
          <td >{{"conditions.long_form.atm_balance_inquiry_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.using_your_card_outside" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.international_transaction_pin" | translate}}</td>
          <td>$0.50 + 3%</td>
          <td >{{"conditions.long_form.international_transaction_pin_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.international_transaction_signature" | translate}}</td>
          <td>$0.00 + 3%</td>
          <td >{{"conditions.long_form.international_transaction_signature_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.international_atm_withdrawal" | translate}}</td>
          <td>$2.50 + 3%</td>
          <td >{{"conditions.long_form.international_atm_withdrawal_fee" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.international_atm_balance_inquiry" | translate}}</td>
          <td>$0.50</td>
          <td >{{"conditions.long_form.international_atm_balance_inquiry_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.third_party_fees" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.cash_reload" | translate}}</td>
          <td>$4.99</td>
          <td >{{"conditions.long_form.cash_reload_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.other" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.inactivity" | translate}}</td>
          <td>$1.00</td>
          <td >{{"conditions.long_form.inactivity_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3" >{{"conditions.long_form.money_transfer" | translate}}</td>
        </tr>
        <tr>
          <td >{{"conditions.long_form.card_to_card_transfers" | translate}}</td>
          <td>$0.50</td>
          <td >{{"conditions.long_form.card_to_card_transfers_fee" | translate}}</td>
        </tr>
        <tr>
          <td colspan="3">
            <p >{{"conditions.long_form.your_funds" | translate}}</p>
            <p > <strong>{{"conditions.long_form.no_overdraft" | translate}}</strong> </p>
            <p >{{"conditions.long_form.contact_customer_service" | translate:{productName: productName, phoneNumber: phoneNumber } }} <a href="https://{{customerHost}}" target="_blank">{{customerHost}}</a></p>
            <p >{{"conditions.long_form.contact_customer_service2" | translate}}</p>
            <p >{{"conditions.long_form.translation_advice" | translate}}</p>
          </td>
        </tr>
        </tbody>
      </table>
      <!-- endregion LongForm -->
      <br>
      <br>
      <!-- region Agreement -->
      <div class="agreement">
        <h4 >{{"conditions.cardholder_agreement" | translate:{productName: productName} }}</h4>
        <!-- region AgreementContact -->
        <div>
          <!--h4 class="text-center" >{{"conditions.cardholder_agreement" | translate:{productName: productName} }}</h4-->
          <h5>{{"conditions.customer_service_contact_information" | translate}}</h5>
          <ul class="list-unstyled">
            <li ><b>{{"conditions.address" | translate}} </b>PO Box 554, Maricopa, Arizona 85139</li>
            <li ><b>{{"conditions.website" | translate}} </b><a href="http://{{customerHost}}" target="_blank">{{customerHost}}</a></li>
            <li ><b>{{"conditions.phone_number" | translate}} </b>1-888-877-2268</li>
          </ul>
        </div>
        <!-- endregion AgreementContact -->

        <!-- region AgreementNotices -->
        <div class="agreement-notices">
          <h5  >{{"conditions.important_notices" | translate}}</h5>
          <ol class="custom-list">
            <li>{{"conditions.important_notices_1" | translate}}</li>
            <li>{{"conditions.important_notices_2" | translate}}</li>
            <li>{{"conditions.important_notices_3" | translate}}</li>
            <li>{{"conditions.important_notices_4" | translate}}</li>
            <li>{{"conditions.important_notices_5" | translate}}</li>
          </ol>
          <p class="ml-2">{{"conditions.this_agreement_text_1" | translate}}<b>{{"conditions.this_agreement_text_2" | translate}}</b>{{"conditions.this_agreement_text_3" | translate:{productName: productName} }}<b>{{"conditions.this_agreement_text_4" | translate}}</b>{{"conditions.this_agreement_text_5" | translate}}<b>{{"conditions.this_agreement_text_6" | translate}}</b>{{"conditions.this_agreement_text_7" | translate}}<b>{{"conditions.this_agreement_text_8" | translate}}</b>{{"conditions.this_agreement_text_9" | translate}}
            <b>{{"conditions.this_agreement_text_10" | translate}}</b>{{"conditions.this_agreement_text_11" | translate}}<b>{{"conditions.this_agreement_text_12" | translate}}</b>{{"conditions.this_agreement_text_13" | translate}}<b>{{"conditions.this_agreement_text_14" | translate}}</b>{{"conditions.this_agreement_text_15" | translate}}<b>{{"conditions.this_agreement_text_16" | translate}}</b>{{"conditions.this_agreement_text_17" | translate}}<b>{{"conditions.this_agreement_text_18" | translate}}</b>{{"conditions.this_agreement_text_19" | translate}}</p>
        </div>
        <!-- endregion AgreementNotices -->
        <ol class="no-bullets">
          <!-- region AgreementAboutYourCard -->
          <li>
            <h5 >{{"conditions.about_your_card" | translate}}</h5>
            <p >{{"conditions.about_your_card_text" | translate}}</p>
            <p >{{"conditions.about_your_card_text_2" | translate}}</p>
          </li>
          <!-- endregion AgreementAboutYourCard -->
          <!-- region AgreementVerifyingYourCard -->
          <li>
            <h5 >{{"conditions.verifying_your_card" | translate}}</h5>
            <p ><b>{{"conditions.verifying_your_card_text_1" | translate}}</b> {{"conditions.verifying_your_card_text_2" | translate}}</p>
            <p ><b>{{"conditions.verifying_your_card_text_3" | translate}}</b> {{"conditions.verifying_your_card_text_4" | translate}}</p>
            <p ><b>{{"conditions.verifying_your_card_text_5" | translate}}</b> {{"conditions.verifying_your_card_text_6" | translate}}</p>
          </li>
          <!-- endregion AgreementVerifyingYourCard -->
          <!-- region AgreementUnauthorizedTransactions -->
          <li><h5 >{{"conditions.unauthorized_transactions" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6 >{{"conditions.unauthorized_transactions_text_1" | translate}}</h6>
                <p >{{"conditions.unauthorized_transactions_text_2" | translate}}</p>
              </li>
              <li>
                <h6 >{{"conditions.unauthorized_transactions_text_3" | translate}}</h6>
                <p >{{"conditions.unauthorized_transactions_text_4" | translate}}</p>
                <p >{{"conditions.unauthorized_transactions_text_5" | translate}}</p>
                <p class="mb-0" ><b>{{"conditions.unauthorized_transactions_text_6" | translate}}</b></p>
                <p >{{"conditions.unauthorized_transactions_text_7" | translate}}</p>
              </li>
              <li>
                <h6 >{{"conditions.unauthorized_transactions_text_8" | translate}}</h6>
                <p >{{"conditions.unauthorized_transactions_text_9" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementUnauthorizedTransactions -->
          <!-- region AgreementUsingYourCard -->
          <li><h5 >{{"conditions.using_your_card" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6 >{{"conditions.using_your_card_text_1" | translate}}</h6>
                <p class="mb-0">{{"conditions.using_your_card_text_2" | translate}}</p>
                <p class="mb-0"><b>{{"conditions.using_your_card_text_3" | translate}}</b></p>
                <p class="mb-0">{{"conditions.using_your_card_text_4" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_5" | translate}}</p>
                <p >{{"conditions.using_your_card_text_5_1" | translate}}</p>
                <p ><b>{{"conditions.using_your_card_text_6" | translate}}</b> {{"conditions.using_your_card_text_7" | translate}}</p>

                <p ><b>{{"conditions.using_your_card_text_8" | translate}}</b> {{"conditions.using_your_card_text_9" | translate:{customerHost: customerHost} }}<b>{{"conditions.using_your_card_text_10" | translate}}</b> {{"conditions.using_your_card_text_11" | translate}}</p>

                <p ><b>{{"conditions.using_your_card_text_12" | translate}}</b> {{"conditions.using_your_card_text_13" | translate}}</p>
              </li>

              <li>
                <h6 >{{"conditions.using_your_card_text_14" | translate}}</h6>
                <table class="table table-bordered limits">
                  <thead >
                  <tr>
                    <th class="text-center align-content-end" colspan="2">{{"conditions.using_your_card_text_15" | translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="bg-dark text-white">
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_16" | translate}}</td>
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_17" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_18" | translate}}</td>
                    <td>$10,000</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_18_1" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_18_2" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_19" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_20" | translate}}</td>
                  </tr>
                  <tr >
                    <td>{{"conditions.using_your_card_text_23" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_24" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_25" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_26" | translate}}</td>
                  </tr>
                  <tr class="bg-dark text-white">
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_27" | translate}}</td>
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_28" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_29" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_30" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_31" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_32" | translate}}</td>
                  </tr>
                  <tr class="bg-dark text-white">
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_33" | translate}}</td>
                    <td class="font-weight-bold">{{"conditions.using_your_card_text_34" | translate}}</td>
                  </tr>
                  <tr>
                    <td>{{"conditions.using_your_card_text_35" | translate}}</td>
                    <td>{{"conditions.using_your_card_text_36" | translate}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">{{"conditions.using_your_card_text_37" | translate}}</td>
                  </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <h6>{{"conditions.using_your_card_text_38" | translate}}</h6>
                <p>{{"conditions.using_your_card_text_39" | translate}}<b>{{"conditions.using_your_card_text_40" | translate}}</b>{{"conditions.using_your_card_text_41" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.using_your_card_text_42" | translate}}</h6>
                <p class="mb-0">{{"conditions.using_your_card_text_43_1" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_43_2" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_43_3" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_43_4" | translate}}</p>

                <p class="mb-0">{{"conditions.using_your_card_text_44" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_45" | translate}}</p>
                <p class="mb-0">{{"conditions.using_your_card_text_45_1" | translate}}</p>

                <p style="text-indent: 0;">{{"conditions.using_your_card_text_46" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementUsingYourCard -->
          <!-- region AgreementConfidentiality -->
          <li>
            <h5>{{"conditions.confidentiality" | translate}}</h5>
            <p class="mb-0">{{"conditions.confidentiality_text" | translate}}</p>
            <p class="mb-0">{{"conditions.confidentiality_text_1" | translate}}</p>
            <p class="mb-0">{{"conditions.confidentiality_text_2" | translate}}</p>
            <p class="mb-0">{{"conditions.confidentiality_text_3" | translate}}</p>
            <p class="mb-0">{{"conditions.confidentiality_text_4" | translate}}</p>
            <p class="mb-0">{{"conditions.confidentiality_text_5" | translate}}</p>
            <p>{{"conditions.confidentiality_text_6" | translate}}</p>
          </li>
          <!-- endregion AgreementConfidentiality -->
          <!-- region AgreementDocumentation -->
          <li><h5>{{"conditions.documentation" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6>{{"conditions.documentation_text_1" | translate}}</h6>
                <p class="mb-0">{{"conditions.documentation_text_2" | translate}}</p>
                <p>{{"conditions.documentation_text_2_1" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.documentation_text_3" | translate}}</h6>
                <p class="mb-0">{{"conditions.documentation_text_4" | translate}}</p>
                <p>{{"conditions.documentation_text_5" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementDocumentation -->
          <!-- region AgreementTransactionsAndTransfers -->
          <li><h5>{{"conditions.transactions_and_transfers" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_1" | translate}}</h6>
                <p>{{"conditions.transactions_and_transfers_text_2" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_3" | translate}}</h6>
                <p>{{"conditions.transactions_and_transfers_text_4" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_5" | translate}}</h6>
                <p>{{"conditions.transactions_and_transfers_text_6" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_7" | translate}}</h6>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_8" | translate}}</p>

                <p class="mb-0">{{"conditions.transactions_and_transfers_text_9" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_10" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_11" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_12" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_13" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_14" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_15" | translate}}</p>
                <p class="mb-0">{{"conditions.transactions_and_transfers_text_16" | translate}}</p>
                <p>{{"conditions.transactions_and_transfers_text_17" | translate}}</p>
              </li>

              <li>
                <h6>{{"conditions.transactions_and_transfers_text_18" | translate}}</h6>
                <p>{{"conditions.transactions_and_transfers_text_19" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_20" | translate}}</h6>
                <p >{{"conditions.transactions_and_transfers_text_21" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.transactions_and_transfers_text_22" | translate}}</h6>
                <p>{{"conditions.transactions_and_transfers_text_23" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementTransactionsAndTransfers -->
          <!-- region AgreementErrorResolutionProcedures -->
          <li>
            <h5>{{"conditions.error_resolution_procedures" | translate}}</h5>
            <p class="mb-0"><b>{{"conditions.error_resolution_procedures_text_1" | translate}}</b> {{"conditions.error_resolution_procedures_text_2" | translate}}</p>

            <p class="mb-0">{{"conditions.error_resolution_procedures_text_3" | translate}}</p>
            <p class="mb-0">{{"conditions.error_resolution_procedures_text_4" | translate}}</p>
            <p class="mb-0">{{"conditions.error_resolution_procedures_text_5" | translate}}</p>

            <p class="mb-0">{{"conditions.error_resolution_procedures_text_6" | translate}}</p>
            <p class="mb-0">{{"conditions.error_resolution_procedures_text_7" | translate}}</p>
            <p>{{"conditions.error_resolution_procedures_text_8" | translate}}</p>
          </li>
          <!-- endregion AgreementErrorResolutionProcedures -->
          <!-- region AgreementAdditionalTermsAgreement -->
          <li>
            <h5>{{"conditions.additional_terms_agreement" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6>{{"conditions.additional_terms_agreement_text_1" | translate}}</h6>
                <p >{{"conditions.additional_terms_agreement_text_2" | translate}}<b>{{"conditions.additional_terms_agreement_text_3" | translate}}</b>{{"conditions.additional_terms_agreement_text_4" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.additional_terms_agreement_text_5" | translate}}</h6>
                <p >{{"conditions.additional_terms_agreement_text_6" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.additional_terms_agreement_text_7" | translate}}</h6>
                <p >{{"conditions.additional_terms_agreement_text_8" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.additional_terms_agreement_text_9" | translate}}</h6>
                <p >{{"conditions.additional_terms_agreement_text_0" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.additional_terms_agreement_text_11" | translate}}</h6>
                <p >{{"conditions.additional_terms_agreement_text_12" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementAdditionalTermsAgreement -->
          <!-- region AgreementLegalNotices -->
          <li>
            <h5>{{"conditions.legal_notices" | translate}}</h5>
            <ol type="a" class="no-bullets">
              <li>
                <h6>{{"conditions.legal_notices_text_1" | translate}}</h6>
                <p >{{"conditions.legal_notices_text_2" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.legal_notices_text_3" | translate}}</h6>
                <p >{{"conditions.legal_notices_text_4" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.legal_notices_text_5" | translate}}</h6>
                <p >{{"conditions.legal_notices_text_6" | translate}}</p>
              </li>
              <li>
                <h6>{{"conditions.legal_notices_text_7" | translate}}</h6>
                <p >
                  <strong>
                      {{"conditions.legal_notices_text_8" | translate}}
                  </strong>
                </p>
              </li>
              <li>
                <h6>{{"conditions.legal_notices_text_9" | translate}}</h6>
                <p >{{"conditions.legal_notices_text_10" | translate}}</p>
              </li>
            </ol>
          </li>
          <!-- endregion AgreementLegalNotices -->
          <!-- region AgreementJuryTrialWaiver -->
          <li>
            <h5>{{"conditions.jury_trial_waiver" | translate}}</h5>
            <p class="font-weight-bold" >{{"conditions.jury_trial_waiver_text" | translate}}</p>
          </li>
          <!-- endregion AgreementJuryTrialWaiver -->
          <!-- region AgreementArbitrationClause -->
          <li><h5>{{"conditions.arbitration_clause" | translate}}</h5>
            <p >{{"conditions.arbitration_clause_text_1" | translate}}<b>{{"conditions.arbitration_clause_text_2" | translate}}</b>{{"conditions.arbitration_clause_text_3" | translate}}</p>
          </li>
          <!-- endregion AgreementArbitrationClause -->
        </ol>
        <!-- region AgreementArbitrationClauseTable -->
        <table class="table table-bordered table-responsive arbitration-clause">
          <thead>
          <tr>
            <th colspan="3" class="text-center font-weight-bold">{{"conditions.arbitration_clause_text_4" | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="font-weight-bold">
            <td>{{"conditions.arbitration_clause_text_5" | translate}}</td>
            <td>{{"conditions.arbitration_clause_text_6" | translate}}</td>
            <td class="text-center">{{"conditions.arbitration_clause_text_7" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_8" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_9" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_10" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_11" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_12" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_13" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_14" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_15" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_16" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_17" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_18" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_19" | translate}}</td>
          </tr>
          <tr>
            <td>{{"conditions.arbitration_clause_text_20" | translate}}</td>
            <td>{{"conditions.arbitration_clause_text_21" | translate}}</td>
            <td>{{"conditions.arbitration_clause_text_22" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_23" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_24" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_25" | translate}} <b>{{"conditions.arbitration_clause_text_26" | translate}}</b></td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_27" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_28" | translate}}</td>
            <td>
              {{"conditions.arbitration_clause_text_29" | translate}}
              <ul>
                <li>{{"conditions.arbitration_clause_text_30" | translate}}<a href="http://www.adr.org/" target="_blank"> </a><a href="http://www.adr.org/" target="_blank">www.adr.org</a><a href="http://www.adr.org/" target="_blank">.</a> </li>
                <li>{{"conditions.arbitration_clause_text_31" | translate}}<a href="http://www.jamsadr.org/" target="_blank"> www.jamsadr.org</a></li>
                <li>{{"conditions.arbitration_clause_text_32" | translate}}</li>
              </ul>
              {{"conditions.arbitration_clause_text_33" | translate}}
            </td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_34" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_35" | translate}}</td>
            <td class="translate-new-line">{{"conditions.arbitration_clause_text_36" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_37" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_37_1" | translate}}</td>
            <td>
              {{"conditions.arbitration_clause_text_38" | translate}}
              <ol class="mb-0">
                <li>{{"conditions.arbitration_clause_text_39" | translate}}</li>
                <li>{{"conditions.arbitration_clause_text_40" | translate}}</li>
                <li>{{"conditions.arbitration_clause_text_41" | translate}}</li>
                <li>{{"conditions.arbitration_clause_text_42" | translate}}</li>
                <li>{{"conditions.arbitration_clause_text_43" | translate}}</li>
              </ol>
              {{"conditions.arbitration_clause_text_44" | translate}}
            </td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_45" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_46" | translate}}</td>
            <td ><b>{{"conditions.arbitration_clause_text_47" | translate}}</b> {{"conditions.arbitration_clause_text_48" | translate}} <b>{{"conditions.arbitration_clause_text_49" | translate}}</b> {{"conditions.arbitration_clause_text_50" | translate}} <b>{{"conditions.arbitration_clause_text_51" | translate}}</b> {{"conditions.arbitration_clause_text_52" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_53" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_54" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_55" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_56" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_57" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_58" | translate}}</td>
          </tr>
          <tr>
            <td class="text-center font-weight-bold" colspan="3" >{{"conditions.arbitration_clause_text_59" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_60" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_61" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_62" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_63" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_64" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_65" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_66" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_67" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_68" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_69" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_70" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_71" | translate}}</td>
          </tr>
          <tr>
            <td class="text-center font-weight-bold" colspan="3" >{{"conditions.arbitration_clause_text_72" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_73" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_74" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_75" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_76" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_77" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_78" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_79" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_80" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_81" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_82" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_83" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_84" | translate}}</td>
          </tr>
          <tr>
            <td >{{"conditions.arbitration_clause_text_85" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_86" | translate}}</td>
            <td >{{"conditions.arbitration_clause_text_87" | translate}}</td>
          </tr>
          </tbody>
        </table>
        <!-- endregion AgreementArbitrationClauseTable -->
      </div>
      <!-- endregion Agreement -->
      <div class="agreement-footer">
        <p class="mb-0">{{"conditions.footer" | translate}}</p>
        <p >{{"conditions.footer2" | translate}}</p>
      </div>
<!--      <div class="disclosure">-->
<!--        <p><b>{{"conditions.disclosure_title" | translate}}</b></p>-->
<!--        <p><b>{{"conditions.disclosure_text_1" | translate: {productName: productName} }}</b></p>-->
<!--        <p>{{"conditions.disclosure_text_2" | translate}}<b>{{"conditions.disclosure_text_3" | translate}}</b>{{"conditions.disclosure_text_4" | translate}}<b>{{"conditions.disclosure_text_5" | translate}}</b>{{"conditions.disclosure_text_6" | translate}}<b>{{"conditions.disclosure_text_7" | translate}}</b>{{"conditions.disclosure_text_8" | translate}}<b>{{"conditions.disclosure_text_9" | translate}}</b>{{"conditions.disclosure_text_10" | translate: {productName: productName} }}<b>{{"conditions.disclosure_text_11" | translate}}</b>{{"conditions.disclosure_text_11_1" | translate}}<b>{{"conditions.disclosure_text_11_2" | translate}}</b>{{"conditions.disclosure_text_12" | translate}}<b>{{"conditions.disclosure_text_13" | translate}}</b>{{"conditions.disclosure_text_14" | translate}}<b>{{"conditions.disclosure_text_15" | translate}}</b>{{"conditions.disclosure_text_16" | translate: {productName: productName} }}</p>-->
<!--        <ol>-->
<!--          <li>-->
<!--            <div class="mb-4"><b>{{"conditions.disclosure_text_17" | translate}}</b>{{"conditions.disclosure_text_18" | translate}}</div>-->
<!--            <ul class="mb-4">-->
<!--              <li>{{"conditions.disclosure_text_19" | translate: {productName: productName} }}</li>-->
<!--              <li>{{"conditions.disclosure_text_20" | translate}}</li>-->
<!--              <li>{{"conditions.disclosure_text_21" | translate}}</li>-->
<!--              <li>{{"conditions.disclosure_text_22" | translate}}</li>-->
<!--              <li>{{"conditions.disclosure_text_23" | translate}}</li>-->
<!--              <li>{{"conditions.disclosure_text_24" | translate}}</li>-->
<!--              <li>{{"conditions.disclosure_text_25" | translate}}</li>-->
<!--            </ul>-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_26" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_27" | translate}}-->
<!--            <a href="https://{{this.customerHost}}" target="_blank">{{this.customerHost}}</a>-->
<!--            {{"conditions.disclosure_text_28" | translate}}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_29" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_30" | translate: {phoneNumber: phoneNumber} }}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_31" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_32" | translate}}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_33" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_34" | translate}}-->
<!--            <ul>-->
<!--              <li>{{"conditions.disclosure_text_35" | translate}}</li>-->
<!--            </ul>-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_36" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_37" | translate}}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_38" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_39" | translate}}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_40" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_41" | translate}}-->
<!--          </li>-->
<!--          <li>-->
<!--            <b>{{"conditions.disclosure_text_42" | translate}}</b>-->
<!--            {{"conditions.disclosure_text_43" | translate}}-->
<!--          </li>-->
<!--        </ol>-->
<!--      </div>-->
    </div>
  </div>

  <app-privacy></app-privacy>

</div>
